import { useLanguage } from "../../context/LanguageContext";
import { PACKAGES } from "./orderOptions";
import { StepNav } from "./OrderControls";
export const PackageStep = ({ order }) => {
  const { t } = useLanguage();
  return <div>
    <h2 className="font-display text-xl font-semibold text-slate-100">{t("Choose your package")}</h2>
    <div className="mt-6 grid gap-4 sm:grid-cols-2">
      {PACKAGES.map(pkg => <button key={pkg.id} data-testid={`order-package-${pkg.id}`} aria-pressed={order.form.package === pkg.id}
        onClick={() => order.setField("package", pkg.id)} className={`rounded-xl border p-5 text-left transition-colors duration-200 ${order.form.package === pkg.id ? "border-[#E5A93C] bg-[#1A1D2B]" : "border-[#282C3D] hover:border-[#3a4059]"}`}>
        <div className="flex items-center justify-between gap-2"><pkg.icon size={20} className="text-[#FFC857]" /><span className="font-mono text-xs text-[#FFC857]">{t(pkg.price)}</span></div>
        <p className="mt-3 font-display text-base font-semibold text-slate-100">{t(pkg.name)}</p>
        <p className="mt-1 text-sm leading-relaxed text-slate-400">{t(pkg.desc)}</p>
      </button>)}
    </div>
    <StepNav onNext={() => order.setStep(1)} nextDisabled={!order.form.package} />
  </div>;
};